module.exports = __webpack_public_path__ + "static/img/chinaPoint.51bb1cda.svg";